import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import { initialSliceEndpoints, initialSliceHosts, sliceCasesEndpoints, sliceCasesHosts } from './actions'

interface CognitiveSettingsState {
  hosts: typeof initialSliceHosts.hosts
  endpoints: typeof initialSliceEndpoints.endpoints
}

const initialState: CognitiveSettingsState = {
  ...initialSliceHosts,
  ...initialSliceEndpoints,
}

export const cognitiveSettingsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder).addSlice(sliceCasesHosts).addSlice(sliceCasesEndpoints)
})
